/// <reference types="node" />
// correctly type "require"
import memoize from 'lodash/memoize';
import getLanguageFromLocale from '@atlassian/jira-common-localisation/src/utils/get-language-from-locale.tsx';
import { getIntl } from '@atlassian/jira-intl/src/get-intl.tsx';
import type { MessageDescriptor } from '@atlassian/jira-intl/src/index.tsx';

export type MessageValues = {
	[key: string]: string | number;
};

export const createFormatMessage: (
	locale: string,
) => (messageDescriptor: MessageDescriptor, messageValues?: MessageValues) => string = memoize(
	(locale: string) => {
		// TODO: providing locale to IntlProvider is nothing to do with translation. We can completely remove language, not providing any locale
		// TODO: React-intl just reads whatever given to messages object, regardless of locale. REMOVE THIS
		// IntlProvider cannot deal with locale w/ country code. Needs language-only.
		const language = getLanguageFromLocale(locale);
		// disable eslint for both unresolved module
		// oxlint-disable-next-line typescript/no-require-imports
		const messages = require('language-pack');
		const intl = getIntl({ locale: language, messages });
		return intl.formatMessage;
	},
);
